import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function SubscriptionSuccess() {
  const [searchParams] = useSearchParams();
  const [loaded, setLoaded] = useState(false);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      padding: '120px 5% 80px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        maxWidth: '600px',
        textAlign: 'center',
        opacity: loaded ? 1 : 0,
        transform: loaded ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
      }}>
        {/* Success Icon */}
        <div style={{
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(80, 227, 194, 0.2) 0%, rgba(80, 227, 194, 0.05) 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 2rem',
          border: '2px solid rgba(80, 227, 194, 0.4)',
        }}>
          <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#50e3c2" strokeWidth="2.5">
            <polyline points="20,6 9,17 4,12" />
          </svg>
        </div>

        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: 700,
          color: '#ffffff',
          marginBottom: '1rem',
        }}>
          Welcome to Parametrix Capital!
        </h1>

        <p style={{
          color: '#a8c5e6',
          fontSize: '1.15rem',
          lineHeight: 1.7,
          marginBottom: '2rem',
        }}>
          Your subscription is now active. You'll receive your first 
          Crypto Market Report on the next Monday.
        </p>

        {/* What's Next */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.02)',
          border: '1px solid rgba(74, 158, 255, 0.15)',
          borderRadius: '12px',
          padding: '2rem',
          marginBottom: '2rem',
          textAlign: 'left',
        }}>
          <h3 style={{
            color: '#4a9eff',
            fontSize: '0.9rem',
            fontWeight: 600,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            marginBottom: '1.25rem',
          }}>
            What Happens Next
          </h3>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
          }}>
            {[
              { icon: '📧', text: 'Check your email for a confirmation message' },
              { icon: '📊', text: 'Your first report arrives next Monday morning' },
              { icon: '💳', text: 'Manage your payment method or cancel anytime in the customer portal' },
              { icon: '🔒', text: 'Your reports will be watermarked to your subscription' },
            ].map((item, index) => (
              <li key={index} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                padding: '0.75rem 0',
                borderBottom: index < 3 ? '1px solid rgba(74, 158, 255, 0.1)' : 'none',
              }}>
                <span style={{ fontSize: '1.25rem' }}>{item.icon}</span>
                <span style={{ color: '#b8d4f1', fontSize: '0.95rem' }}>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Manage Subscription */}
        <div style={{
          padding: '1.5rem',
          background: 'rgba(74, 158, 255, 0.05)',
          border: '1px solid rgba(74, 158, 255, 0.1)',
          borderRadius: '10px',
          marginBottom: '2rem',
        }}>
          <p style={{
            color: '#a8c5e6',
            fontSize: '0.9rem',
            margin: 0,
          }}>
            Need to update your payment method or cancel?{' '}
            <a
              href="https://billing.stripe.com/p/login/9B65kE7Cz0tj8TRcn58EM00"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#4a9eff', textDecoration: 'none' }}
            >
              Manage your subscription →
            </a>
          </p>
        </div>

        {/* Return Home */}
        <Link
          to="/"
          style={{
            display: 'inline-block',
            padding: '1rem 2.5rem',
            background: 'linear-gradient(135deg, #4a9eff 0%, #1a6ed8 100%)',
            border: 'none',
            borderRadius: '8px',
            color: '#ffffff',
            fontSize: '1rem',
            fontWeight: 600,
            textDecoration: 'none',
            boxShadow: '0 4px 20px rgba(74, 158, 255, 0.3)',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={e => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 25px rgba(74, 158, 255, 0.4)';
          }}
          onMouseLeave={e => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 20px rgba(74, 158, 255, 0.3)';
          }}
        >
          Return to Homepage
        </Link>

        {/* Questions */}
        <p style={{
          marginTop: '2rem',
          color: '#6b9bc9',
          fontSize: '0.9rem',
        }}>
          Questions? <Link to="/contact" style={{ color: '#4a9eff', textDecoration: 'none' }}>Contact us</Link>
        </p>
      </div>
    </div>
  );
}
